export default __webpack_public_path__ + "static/media/ruler-alt.6c5674d8.svg";